import axios from '../api/axiosInstance';

export const searchCustomers = (query) => {
  return axios.get('/customers', { params: { search: query } });
};

export const createCustomer = (data) => {
  return axios.post('/customers', data);
};

export const searchShopProducts = (shopId, query) => {
  // Backend expects `search` parameter for filtering shop products
  return axios.get(`/shops/${shopId}/products`, { params: { search: query } });
};

export const addManualProduct = (shopId, data) => {
  return axios.post(`/shops/${shopId}/products`, data);
};

export const estimateOrder = (data) => {
  return axios.post('/orders/estimate', data);
};

export const createOrder = (customerId, data) => {
  return axios.post(`/customers/${customerId}/phone-orders`, data);
};

// Fetch orders with optional filters like `search` (order number) and `status`
export const fetchOrders = (params = {}) => {
  return axios.get('/orders', { params });
};

export const fetchAvailableDeliveryBoys = () => {
  return axios.get('/delivery-boys', { params: { available: 1 } });
};

export const assignDeliveryBoy = (orderId, payload) => {
  const body =
    payload && typeof payload === 'object'
      ? payload
      : { deliveryBoyId: payload };
  return axios.post(`/orders/${orderId}/assign`, body);
};

export const fetchOrder = (id) => {
  return axios.get(`/orders/${id}`);
};

export const updateOrderStatus = (id, status) => {
  return axios.patch(`/orders/${id}/status`, { status });
};

export const updateOrder = (id, data) => {
  return axios.put(`/orders/${id}`, data);
};

export const updateOrderShopStatus = (orderId, orderShopId, status) => {
  return axios.patch(`/orders/${orderId}/shops/${orderShopId}/status`, { status });
};

export const updateOrderShopSettlementStatus = (orderId, orderShopId, settlementPaid) => {
  return axios.patch(`/orders/${orderId}/shops/${orderShopId}/settlement`, { settlementPaid });
};

